  /* Component Dependencies */
var mediaViewerTemplate = require('templates/mediaViewer.hbs');
var mediaViewerPhotosTemplate = require('templates/mediaViewer-photos.hbs');
var mediaViewerTiersTemplate = require('templates/mediaViewer-tiers.hbs');
var mediaViewerQuickGroupTemplate = require('templates/mediaViewer-quickGroup.hbs');
var Marzipano = require('../../../../../core/libs/marzipano');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');
var marzipanoConfig = require('./config/marzipanoConfig');
var $ = require('jquery');

AriesComponent.create({
  type: 'mediaViewer',
  template: {
    'mediaViewer': mediaViewerTemplate,
    'mediaViewer-photos': mediaViewerPhotosTemplate,
    'mediaViewer-quickGroup': mediaViewerQuickGroupTemplate,
    'mediaViewer-tiers': mediaViewerTiersTemplate
  },
  subscribe: {
    'CLEAR_MARZIPANO_DATA': 'clearMarzipanoData'
  },
  events: {
    'click .m-pano__control': 'panoViewerControl'
  },
  constants: {
    GROUP_SEARCH_HEIGHT: '329px'
  },
  bindEvents: function($) {
    var _self = this,
      $dropdown, $carousel, categoryDropdown, selectric;
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
    _self.isGroupSearch = _self.$el.data('isGroupSearch');
    _self.isQuickGroup = _self.$el.data('is-quick-group');
    _self.panoViewer = {};
    if (_self.$el.children('.tile-media-viewer-photos').length) {
      _self.registerPopup();
      _self.$showAllBtn = _self.$el.find('.l-photo__list .is-show-all');
      _self.$photoCount = _self.$el.find('.l-photo-count');
      _self.$categoryBtn = _self.$el.find('.l-photo__list li');
      _self.$el.find('.l-photo__list').on('click', 'li button', _self.filterCategory.bind(_self));
      _self.$mediaViewerSelector = _self.$el.find('.js-media-viewer-trigger');
      _self.$mediaViewerSelector.on('mfpOpen', _self.onMediaViewerOpen.bind(_self));
      _self.$mediaViewerSelector.on('mfpClose', _self.onMediaViewerClose.bind(_self));
    } else if (_self.$el.hasClass('tile-photo-viewer')) {
      $dropdown = _self.parentSelector.find('.mi-select');
      $carousel = _self.parentSelector.find('.mi-carousel');
      _self.$galleryWrapper = _self.parentSelector.find('.mi-gallery .article-content');
      if (_self.parentSelector.find('.slick-initialized').length) {
        _self.onSlickInit.call(_self);
      } else {
        $carousel.on('init', function () {
          _self.onSlickInit.call(_self);
        });
      }
      $dropdown.on('selectric-init', function () {
        _self.$el.find('#selectric-list0 li').attr('tabindex', '1');
      });
      $(document).on('keydown', function (e) {
        if (e.keyCode === 9) {
          setTimeout(function () {
            if ($(document.activeElement).closest('.selectric-wrapper').length) {
              _self.$el.find('.selectric-wrapper .label').css('font-weight', '600');
            } else {
              _self.$el.find('.selectric-wrapper .label').css('font-weight', '');
            }
          }, 1);
        }
      });

      categoryDropdown = _self.parentSelector.find('.selectric-items');

      //closing dropdown on outside click
      _self.parentSelector.not(categoryDropdown).on('click', function (e) {
        selectric = _self.$el.find('.selectric-wrapper');
        if (selectric.hasClass('selectric-open')) {
          _self.$el.find('.selectric').click();
        }
      });
      //prevents popup to be closed on pressing key
      _self.parentSelector.find('.selectric-wrapper').on('keyup keypress keydown', function (e) {
        e.stopPropagation();
      });

      $dropdown.on('change', _self.navigateToNewCategory.bind(_self));
      _self.parentSelector.find('.mi-gallery .mi-carousel').on('beforeChange', _self.changePaginationOnSlideChange.bind(_self));

      $carousel.on('afterChange', function (event, slick, currentSlide) {
        // load next and previous images
        var $nextSlide, $previousSlide,
          $currentSlide = slick.$slides.eq(currentSlide),
          $currentSlideImg = $currentSlide.find('img');
        if ((currentSlide + 1) < slick.$slides.length) {
          $nextSlide = slick.$slides.eq(currentSlide + 1);
          nextSlideIndex = $nextSlide.data('slick-index');
          $previousSlide = slick.$slides.eq(currentSlide - 1);
          previousSlideIndex = $previousSlide.data('slick-index');
        } else {
          // reset slide traversing
          $nextSlide = slick.$slides.eq(0);
          $previousSlide = slick.$slides.eq(currentSlide - 1);
        }
        if ($nextSlide.hasClass('l-picture-wrapper')) {
          _self.loadImage($nextSlide);
        }
        if ($previousSlide.hasClass('l-picture-wrapper')) {
          _self.loadImage($previousSlide);
        }
        if ($nextSlide.hasClass('l-pano-wrapper')) {
          _self.initPanoramicView($nextSlide, nextSlideIndex, 'next');
        }
        if ($previousSlide.hasClass('l-pano-wrapper')) {
          _self.initPanoramicView($previousSlide, previousSlideIndex, 'previous');
        }
        if ($currentSlide.hasClass('l-picture-wrapper') && $currentSlideImg.attr('src') === '') {
          $currentSlideImg.attr('src', $currentSlideImg.data('src'));
        }
      });

      $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $currentSlide, $nextSlide;
        if (currentSlide !== nextSlide) {
          $currentSlide = slick.$slides.eq(currentSlide);
          $nextSlide = slick.$slides.eq(nextSlide);
          if ($currentSlide.hasClass('l-pano-wrapper') && _self.panoViewer[currentSlide]) {
            _self.panoViewer[currentSlide].viewer.setIdleMovement(Infinity);
            _self.panoViewer[currentSlide].viewer.stopMovement();
          } else if ($currentSlide.hasClass('l-video-wrapper') && !$currentSlide.find('video').get(0).paused) {
            $currentSlide.find('video').get(0).pause();
          }
          if ($nextSlide.hasClass('l-pano-wrapper') && _self.panoViewer[nextSlide]) {
            _self.panoViewer[nextSlide].viewer
              .setIdleMovement(marzipanoConfig.viewer.autorotateIdle, _self.panoViewer[nextSlide].autorotate);
            _self.panoViewer[nextSlide].viewer.startMovement(_self.panoViewer[nextSlide].autorotate);
          } else if ($nextSlide.hasClass('video-slide')) {
            $nextSlide.find('iframe').attr('src', $nextSlide.data('videoLinkUrl'));
          }
        }
      });
    }
    /* prevent videojs default styles */
    window.VIDEOJS_NO_DYNAMIC_STYLE = true;
    /* ensure videojs plugin is attached to video element when the content is loaded in a overlay*/
    $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-video');

    _self.highResMedia = window.matchMedia("(min-resolution: 192dpi), (-webkit-min-device-pixel-ratio: 2), (min--moz-device-pixel-ratio: 2), (-o-min-device-pixel-ratio: 2/1), (min-device-pixel-ratio: 2), (min-resolution: 2dppx)");
    _self.mediaTablet = window.matchMedia("(min-width: 600px)");
    _self.mediaDesktop = window.matchMedia("(min-width: 769px)");
    
  },

  /**
   * Register popup to show photo category list, image caption and media viewer modal
   * @return {void}
   */
  registerPopup: function () {
    var _self = this,
      categoryListPopup, imageCaptionPopup;
    categoryListPopup = new Popup({
      items: {
        src: '.tile-media-viewer-photos .l-photo__list',
        type: 'inline'
      },
      selector: '.tile-media-viewer-photos .js-photo-list-trigger',
      alternateCloseMarkup: true
    });
    categoryListPopup.register();
    imageCaptionPopup = new Popup({
      type: 'inline',
      selector: '.tile-media-viewer-photos .js-image-caption',
      alternateCloseMarkup: true
    });
    imageCaptionPopup.register();
    _self.mediaViewerPopup = new Popup({
      selector: '.tile-media-viewer-photos .js-media-viewer-trigger',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true,
      fullScreen: true,
      mainClass: 'mi-gallery mi-gallery-full'
    });
    _self.mediaViewerPopup.register();
  },
  /*
   * Filter photos based on user selection
   * @param {Object} event object is passed
   * @return {void}
   */
  filterCategory: function (event) {
    var _self = this,
      $targetElm = $(event.currentTarget),
      photoCount, $videoPanel;
    if (_self.$el.find(".tile-media-viewer-tiers")) {
      if ($targetElm.closest('.l-main-trigger-container').length) {
        if(!$targetElm.hasClass('is-active')){
          $videoPanel = _self.$el.find('#' + _self.$el.find('.l-videos-button').attr('aria-controls'));
          if ($targetElm.hasClass('l-videos-button')) {
            // video selected
            _self.$el.find('.m-photo__panel-container div.l-clear:last-child').show();
            _self.$el.find('.m-photo__trigger').hide();
            if ($videoPanel.css("display") === "none") {
              $videoPanel.css("display", "block");
            }
            $videoPanel.find('h2').addClass('l-display-none l-padding-none');
            $targetElm.removeClass('m-button-secondary').addClass('m-button-primary is-active');
            $targetElm.closest('ul').find('.l-photos-button').removeClass('m-button-primary is-active').addClass('m-button-secondary');
            _self.$el.find('.m-photo__panel').hide();
            _self.$el.find('.m-photo__panel-container div.l-clear:last-child').show();
          } else {
            // photos selected
            _self.$el.find('.m-photo__trigger').show();
            $videoPanel.find('h2').removeClass('l-display-none l-padding-none');
            $targetElm.removeClass('m-button-secondary').addClass('m-button-primary is-active');
            $targetElm.closest('ul').find('.l-videos-button').removeClass('m-button-primary is-active').addClass('m-button-secondary');
            _self.$el.find('.m-photo__panel').slideDown();
            if (!_self.$showAllBtn.hasClass('is-active')) {
              _self.$categoryBtn.find('button').slice(1).removeClass('is-active');
              _self.$showAllBtn.removeClass('m-button-secondary').addClass('m-button-primary is-active');
            }
            _self.$el.find('.m-photo__panel-container .l-videos-container').hide();
          }
        }
      }
      else {
        if ($targetElm.hasClass('is-show-all')) {
          if (!$targetElm.hasClass('is-active')) {
            $targetElm.removeClass('t-bg-standard-20 t-color-standard-10').addClass('m-button-primary is-active');
            $targetElm.closest('ul').find('button').slice(1).removeClass('is-active');
            _self.$el.find('.m-photo__panel').slideDown();
            photoCount = _self.$photoCount.data('photoAll');
            _self.$photoCount.text(photoCount);
            _self.$el.find('.m-photo__panel-container .l-videos-container').hide();
          }
        } else {
          if (_self.$showAllBtn.hasClass('is-active')) {
            _self.$showAllBtn.removeClass('m-button-primary is-active').addClass('t-bg-standard-20 t-color-standard-10');
            _self.$el.find('.m-photo__panel').not(_self.$el.find('#' + $targetElm.attr('aria-controls')).eq(0)).slideUp();
          } else {
            _self.$el.find('#' + $targetElm.attr('aria-controls')).slideDown();
          }
          $targetElm.addClass('is-active');
          photoCount = _self.$categoryBtn.find('.is-active').length - 1;
          _self.$photoCount.text(photoCount);
          _self.$el.find('.m-photo__panel-container .l-videos-container').hide();
        }
      }
    }
    else if ($targetElm.hasClass('is-show-all')) {
      if (!$targetElm.hasClass('is-active')) {
        $targetElm.removeClass('t-bg-standard-20 t-color-standard-10').addClass('is-active');
        $targetElm.closest('ul').find('button').slice(1).removeClass('is-active');
        _self.$el.find('.m-photo__panel').slideDown();
        photoCount = _self.$photoCount.data('photo-all');
        _self.$photoCount.text(photoCount);
      }
    } else {
      if (_self.$showAllBtn.hasClass('is-active')) {
        _self.$showAllBtn.removeClass('is-active').addClass('t-bg-standard-20 t-color-standard-10');
        _self.$el.find('.m-photo__panel').not(_self.$el.find('#' + $targetElm.attr('aria-controls')).eq(0)).slideUp();
      } else {
        _self.$el.find('#' + $targetElm.attr('aria-controls')).slideDown();
      }
      $targetElm.addClass('is-active');
      photoCount = _self.$categoryBtn.find('.is-active').length;
      _self.$photoCount.text(photoCount);
    }
  },
  /**
   * Initialize 360 panoramic view
   * @param {Object} slick - slider slick object is passed
   * @return {void}
   */
  initPanoramicView: function ($slide, slideIndex, slide) {
    var _self = this,
       panoView, source, geometry, limiter, view, scene, velocity, friction, controls;
    // Dynamic parameters for controls.
    velocity = marzipanoConfig.viewer.velocity;
    friction = marzipanoConfig.viewer.friction;
      panoView = {};
        // Grab pano viewer element from DOM.
        panoView.$el = $slide.find('.m-pano').eq(0);
        // Initialize viewer.
        panoView.viewer = new Marzipano.Viewer(panoView.$el.get(0));
        // Setup autorotate.
        panoView.autorotate = Marzipano.autorotate(marzipanoConfig.viewer.autorotate);

        if (panoView.$el.hasClass('m-pano--360L')) {
          // Create scenes.
          panoView.scenes = marzipanoConfig.scenes.map(function (data) {
            source = Marzipano.ImageUrlSource.fromString(panoView.$el.data('imageFolderPath') +
              marzipanoConfig.viewer.multiImgSrc + panoView.$el.data('fileType'));
            geometry = new Marzipano.CubeGeometry(data.levels);
            limiter = Marzipano.RectilinearView.limit.traditional(data.faceSize, marzipanoConfig.viewer.maxFovLimit);
            view = new Marzipano.RectilinearView(data.initialViewParameters, limiter);
            scene = panoView.viewer.createScene({
              source: source,
              geometry: geometry,
              view: view,
              pinFirstLevel: true
            });
            return {
              data: data,
              scene: scene,
              view: view
            };
          });
          // Display the initial scene.
          panoView.scenes[0].view.setParameters(panoView.scenes[0].data.initialViewParameters);
          panoView.scenes[0].scene.switchTo();
        } else { // 360 image
          source = Marzipano.ImageUrlSource.fromString(panoView.$el.data('imageUrl'));
          geometry = new Marzipano.EquirectGeometry([{width: marzipanoConfig.viewer.imagefaceSize}]);
          limiter = Marzipano.RectilinearView.limit.traditional(marzipanoConfig.viewer.imagefaceSize, marzipanoConfig.viewer.maxFovLimit);
          view = new Marzipano.RectilinearView(marzipanoConfig.scenes[0].initialViewParameters, limiter);
          scene = panoView.viewer.createScene({
            source: source,
            geometry: geometry,
            view: view,
            pinFirstLevel: true
          });
          // Display scene.
          scene.switchTo();
        }

        if ($slide.hasClass('slick-active')) {
          panoView.viewer.setIdleMovement(marzipanoConfig.viewer.autorotateIdle, panoView.autorotate);
          panoView.viewer.startMovement(panoView.autorotate);
        } else {
          panoView.viewer.setIdleMovement(Infinity);
          panoView.viewer.stopMovement();
        }

        // Associate view controls with elements.
        controls = panoView.viewer.controls();
        controls.registerMethod('upElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-up').get(0), 'y', -velocity, friction), true);
        controls.registerMethod('downElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-down').get(0), 'y', velocity, friction), true);
        controls.registerMethod('leftElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-left').get(0), 'x', -velocity, friction), true);
        controls.registerMethod('rightElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-right').get(0), 'x', velocity, friction), true);
        controls.registerMethod('inElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-plus').get(0), 'zoom', -velocity, friction), true);
        controls.registerMethod('outElement', new Marzipano.ElementPressControlMethod($slide.find('.m-pano__control-minus').get(0), 'zoom', velocity, friction), true);
        if(slide == 'current') {
          _self.panoViewer = {};
        }
        _self.panoViewer[slideIndex] = panoView;
        var panoArray = Object.keys(_self.panoViewer).sort();
        if (panoArray.length > 3){
          if(slide == 'next') {
            delete _self.panoViewer[panoArray[0]];
          }
          else if(slide == 'previous'){
            delete _self.panoViewer[panoArray[panoArray.length - 1]];
          }
        }
  },
  /**
   * Prevent browser default action on panoramic view controls
   * @param {Object} event object is passed
   */
  panoViewerControl: function (event) {
    event.preventDefault();
  },
  /**
   * 
   * This method is executed when the carousel is initialized. It performs a couple of operations mentioned in the comments below.
   * @return {Boolean} Success/Failure
   */
  onSlickInit: function _onSlickInit() {
    var _self = this;
    //To focus image on initial load of gallery
    if(!_self.isQuickGroup){
      _self.$el.find('.slick-current').focus();
    }
  
    //This is to load clicked image
    setTimeout(function () {
      var imageSelector = _self.parentSelector,
        imageToShow = imageSelector.find(".mi-carousel").data('mediaid') - 1,
        showCategoryIndex = imageSelector.find('.slider-slide[data-slick-index="' + imageToShow + '"]').data('categoryIndex');
      if (imageToShow) {
        imageSelector.find('.mi-carousel').slick('slickGoTo', imageToShow).end()
          .find('#selectric-list0 li[data-index="' + showCategoryIndex + '"]').trigger("click");
      }
      _self.onCarouselInit.call(_self);
    }, 0);

  },
  /**
   * This method is executed when the selectric dropdown is changed. It is used to navigate to the new selected category. This calls the before-change function of Carousel as callback
   * @return {Boolean} Success/Failure
   */
  navigateToNewCategory: function _navigateToNewCategory() {
    var _self = this,
      $carousel, $select, $nextSlide, nextSlideIndex;
    $select = _self.parentSelector.find('.mi-select');
    nextSlideIndex = $select.find('option:nth-child(' + ($select.get(0).selectedIndex + 1) + ')').data('start-index') - 1;
    $carousel = _self.parentSelector.find('.mi-carousel');
    $nextSlide = $carousel.slick('getSlick').$slides.eq(nextSlideIndex);
    if ($nextSlide.hasClass('l-picture-wrapper')) {
      _self.loadImage($nextSlide);
    }
    $carousel.slick('slickGoTo', nextSlideIndex);
  },
  /**
   * This method is executed whenever dropdown slide is changed. It shows/hides the title and caption accordingly
   * @return {Boolean} Success/Failure
   */
  changePaginationOnSlideChange: function _changePaginationOnSlideChange(event, slick, currentSlide, nextSlide) {
    var currentImageWrapper = this.parentSelector.find('.slick-slide[data-slick-index=' + nextSlide + ']');
    var captionContainer = this.parentSelector.find('.m-caption-container');
    var headerTitle = this.parentSelector.find('.m-gallery-heading');
    // Show title and caption if they are available, hide otherwise
    if (currentSlide !== nextSlide) {
      currentImageWrapper.attr('data-caption') ? captionContainer.show() : captionContainer.hide();
    }
    this.setPaginationContent(event, slick, currentSlide, nextSlide);
  },
  /**
   * This method is executed initially and whenever the carousel state is changed. It is used to change the Pagination value using the start Index and total count
   * @return {Boolean} Success/Failure
   */
  setPaginationContent: function _setPaginationContent(event, slick, currentSlide, nextSlide) {
    var paginationContainer;
    var selectDropdown = this.parentSelector.find('.t-classic');
    var currentImageWrapper = typeof nextSlide === "number" ? (this.parentSelector.find('.slick-slide[data-slick-index=' + nextSlide + ']')) : (this.parentSelector.find('.slick-current'));
    var startIndex = parseInt(currentImageWrapper.data('slick-index')) + 1;
    var mediaCategoryDesc = currentImageWrapper.data('media-category-description');
    var totalSlides = this.parentSelector.find('.t-classic').data('total-image-count');
    var selectricWrapper = this.parentSelector.find('.selectric-wrapper');
    var selectricLabel = this.parentSelector.find('.selectric .label');
    var selectricButton = this.parentSelector.find('.selectric .button');
    var newWidth;
    var currentSelectedOption = this.parentSelector.find('.selected');

    $('.mi-gallery-info-button').removeAttr('title');

    // Updating the selected category in dropdown on slide change through arrow buttons
    if ((typeof currentSelectedOption.data('index') === "number") && (currentSelectedOption.data('index') !== currentImageWrapper.data('category-index'))) {
      selectDropdown.prop('selectedIndex', nextSlide).selectric('refresh');
    }

    //updating the selectric label content on selecting an option from dropdown
    paginationContainer = this.parentSelector.find('.selectric .label');
    paginationContainer.text(mediaCategoryDesc + ' (' + startIndex + '/' + totalSlides + ')');
    if (currentSlide === nextSlide) {
      this.parentSelector.find('#selectric-opt00').text(selectDropdown.find('option:first-of-type').attr('data-media-category-description') + ' (' + selectDropdown.find('option:first-of-type').attr('data-media-count') + ')');
    }

    // Width updated for selectric label if new width exceeds the previous width
    // 32px padding and 2px border included in newWidth
    newWidth = selectricLabel.outerWidth(true) + selectricButton.outerWidth(true) + 50;
    if (newWidth > selectricWrapper.width() + 6) {
      // Additional 2px because selectricItems contains 2px border
      selectricWrapper.width(newWidth + 2);
      this.parentSelector.find('.selectric-items').width(newWidth);
    }
  },
  /**
   * load image dynamically
   * @param {Object} $nextSlide - next slick slide object is passed
   * @return {Void}
   */
  loadImage: function ($nextSlide) {
    var _self = this,
      imgEl = $nextSlide.find('img'),
      imgSrc;
    if (!imgEl.attr('src')) {
      imgEl.on('load', function () {
        _self.calculateDimensions(imgEl, _self.$galleryWrapper);
      });
      imgSrc = imgEl.data('src');
      if (_self.mediaDesktop.matches) {
        imgSrc += (_self.highResMedia.matches) ? '?downsize=2880px:*' : '?downsize=1440px:*';
      } else if (_self.mediaTablet.matches) {
        imgSrc += (_self.highResMedia.matches) ? '?downsize=2880px:*' : '?downsize=768px:*';
      } else {
        imgSrc += (_self.highResMedia.matches) ? '?downsize=1118px:*' : '?downsize=559px:*';
      }
      imgEl.attr('src', imgSrc);
    }
  },
  /**
   * Trigger lazy loading of images and initialize Marzipano viewer
   * @return {Void}
   */
  onCarouselInit: function () {
    var _self = this,
      slick, currentSlideIndex, $currentSlide, $galleryWrapper, $carousel, $slides;
    $carousel = _self.parentSelector.find('.mi-carousel');
    slick = $carousel.slick('getSlick');
    currentSlideIndex = (slick.$slider.data('mediaid') - 1) || slick.slickCurrentSlide();
    $currentSlide = slick.$slides.eq(currentSlideIndex);
    $galleryWrapper = slick.$slider.closest('.article-content');
    if(_self.isGroupSearch){
      carouselHeight = _self.constants.GROUP_SEARCH_HEIGHT;
    }
    else if(_self.isQuickGroup){
      carouselHeight = $(window).width() > 768 ? $galleryWrapper.width()/3 + 'px' : $galleryWrapper.width()/1.78 + 'px';
    }
    else{
      carouselHeight = $galleryWrapper.width()*0.5625 + 'px';
    }
    if ($currentSlide.hasClass('l-picture-wrapper')) {
      _self.loadImage($currentSlide);
    }
    if ($currentSlide.hasClass('l-pano-wrapper')) {
      _self.initPanoramicView($currentSlide, currentSlideIndex, 'current');
    }
    if (slick.$slider.length === 1 && $currentSlide.is('.l-pano-wrapper, .l-video-wrapper, .video-slide')) {
      slick.$slider.next('.m-caption-container').css('display', 'none');
    }
    $galleryWrapper.find('.m-message-info').text($currentSlide.data('caption'));
    $galleryWrapper.find('.m-gallery-heading').text($currentSlide.data('title'));
    if(_self.isQuickGroup){
      $galleryWrapper.find('.l-picture-wrapper').each(function(){
       var currentIndex = $(this).data('photo');
       $(this).attr({"data-photo":currentIndex+1});
      });
      $galleryWrapper.find('.m-image-order').text($currentSlide.attr('data-photo'));
      $galleryWrapper.find('.js-total-image-number').text($currentSlide.data('total-count'));
    }
    $slides = $carousel.find('.slider-slide');
    $slides.height(carouselHeight);
    $slides.css({
      'maxHeight': ($(window).height() - $galleryWrapper.find('.mi-gallery-header').outerHeight()) + 'px'
    });
  },
  /**
   * Clear Marzipano viewer data callback
   * @return {Void}
   */
  clearMarzipanoData: function () {
    var _self = this,
      sceneIndex;
    if (_self.$el.hasClass('tile-photo-viewer') && _self.panoViewer) {
      for (sceneIndex in _self.panoViewer) {
        _self.panoViewer[sceneIndex].viewer.destroy();
      }
      delete _self.panoViewer;
    }
  },
  /*
   * Register browser full screen change listener on modal open to conditionally trigger popup close
   * @return {Void}
   */
  onMediaViewerOpen: function () {
    var _self = this;
    //IE11 fix to prevent modal from being closed when exiting from browser full screen mode
    if ($('html').hasClass('ie11')) {
      $(document).on('MSFullscreenChange.mediaViewer', function (e) {
        if (document.msFullscreenElement === null) {
          setTimeout(function () {
            $(document).on('keyup.mfp', function (e) {
              if (e.keyCode === 27) {
                _self.pubsub.publish('POPUP_CLOSE');
              }
            });
          }, 1000);
        } else {
          $(document).off('keyup.mfp');
        }
      });
    }
  },
  /*
   * Clear Marzipano viewer data on modal close
   * @return {Void}
   */
  onMediaViewerClose: function () {
    var _self = this;
    _self.pubsub.publish('CLEAR_MARZIPANO_DATA');
    if ($('html').hasClass('ie11')) {
      $(document).off('MSFullscreenChange.mediaViewer');
    }
  },
  /*
   * Add styles based on the actual image dimension
   * @param {Object} $imgEl -jQuery wrapped image element
   * @param {Object} $galleryWrapper - jQuery wrapped mi-gallery element
   * @return {Void}
   */
  calculateDimensions: function ($imgEl, $galleryWrapper) {
    var _self = this,
      imgEl = $imgEl.get(0);
    if (imgEl && imgEl.naturalWidth >= $galleryWrapper.width() && imgEl.naturalHeight >= $galleryWrapper.height()) {
      if (imgEl.naturalWidth > imgEl.naturalHeight) {
        $imgEl.addClass('img-landscape');
      } else {
        $imgEl.addClass('img-portrait');
      }
    } else if (imgEl && imgEl.naturalWidth < $galleryWrapper.width() && imgEl.naturalHeight < $galleryWrapper.height()) {
      $imgEl.addClass('img-natural');
    }
  }
});